import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles/transient-options";

type Props = {
  $color: string;
  $size: string;
};
export const IconStyled = styled("span", { ...transientOptions })<Props>`
  color: ${props => props.$color};
  size: ${props => props.$size};

  /* Prevent the priority is lower than the class material-icons in dev */
  font-size: ${props => props.$size} !important;
`;
